// Small, shared allowlist for stored editorial Markdown. No raw HTML parser.
// External citation URLs remain publisher-name text in every rendering path.
export function inlineTokens(value = '') {
  return String(value ?? '').split(/(\[[^\]\n]+\]\([^\n)]*\)|\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*|_[^_\n]+_|`[^`\n]+`)/g).filter(Boolean).map(part => {
    const link = part.match(/^\[([^\]\n]+)\]\(([^\n)]*)\)$/);
    if (link) return { type: /^\/(?!\/)[^\s\\\u0000-\u001f\u007f]*$/.test(link[2]) ? 'link' : 'text', text: link[1], href: link[2] };
    if (/^(?:\*\*[^*\n]+\*\*|__[^_\n]+__)$/.test(part)) return { type: 'strong', text: part.slice(2, -2) };
    if (/^(?:\*[^*\n]+\*|_[^_\n]+_)$/.test(part)) return { type: 'em', text: part.slice(1, -1) };
    if (part.startsWith('`') && part.endsWith('`')) return { type: 'code', text: part.slice(1, -1) };
    return { type: 'text', text: part };
  });
}

export const plainEditorialText = value => inlineTokens(value).map(token => token.text).join('');
const identity = value => plainEditorialText(value).trim().replace(/\s+/g, ' ').toLocaleLowerCase();

export function editorialPresentation(article) {
  if (!article) return article;
  // Presentation only: never change stored content, translation hashes or facts.
  const result = { ...article };
  for (const key of ['headline', 'subheadline', 'seo_title', 'meta_description', 'excerpt']) {
    if (typeof result[key] === 'string') result[key] = plainEditorialText(result[key]);
  }
  const summaries = new Set([article.subheadline, article.the_dish?.summary].filter(Boolean).map(identity));
  const seen = new Set(summaries);
  result.body = (Array.isArray(article.body) ? article.body : []).filter((block, index, blocks) => {
    if (['h2', 'h3'].includes(block?.type) && /^the dish:?$/i.test(plainEditorialText(block.text).trim()) &&
        summaries.has(identity(blocks[index + 1]?.text || ''))) return false;
    if (block?.type !== 'paragraph') return true;
    const key = identity(block.text);
    if (key && seen.has(key)) return false;
    if (key) seen.add(key);
    return true;
  });
  return result;
}
